import React from 'react';
import PropTypes from 'prop-types';
import { createSurveyStyles } from '@sm/webassets';
import './qz-score-summary.scss';

const useStyles = createSurveyStyles(theme => {
  return {
    qzScoreSummary: {
      ...theme.questionTitle,
      fontFamily: theme.questionBody.fontFamily,
    },
  };
});

const getScorePoints = ({ score, maxScore }) => {
  if (score && maxScore) {
    return (
      <div className="sm-qz-score-summary--points">
        <span>
          {score}/{maxScore} points
        </span>
      </div>
    );
  }
  return null;
};

const getScorePercent = percentScore => {
  if (percentScore) {
    return <div className="sm-qz-score-summary--score">Score: {percentScore}%</div>;
  }
  return null;
};

const getScoreFeedback = feedback => {
  return (
    <>
      {feedback && (
        <div className="sm-qz-score-summary--feedback">
          {feedback.imageUrl && (
            <div className="sm-qz-score-summary--img-container">
              <img
                src={feedback.imageUrl}
                alt={feedback.message || 'Feedback'}
                className="sm-qz-score-summary--image"
              />
            </div>
          )}
          {feedback.message && <div className="sm-qz-score-summary--text">{feedback.message}</div>}
        </div>
      )}
    </>
  );
};

const QuizScoreSummary = ({ score, feedback }) => {
  const { qzScoreSummary } = useStyles();
  const percentScore = (score.percent && score.percent.toFixed(2)) || '';
  return (
    <div className={`sm-qz-score-summary--container ${qzScoreSummary}`} data-testid="QuizScoreSummary__Container">
      {getScoreFeedback(feedback)}
      {getScorePercent(percentScore)}
      {getScorePoints(score)}
    </div>
  );
};

QuizScoreSummary.propTypes = {
  score: PropTypes.shape({
    feedback: PropTypes.string,
    score: PropTypes.number,
    maxScore: PropTypes.number,
    percent: PropTypes.number,
  }).isRequired,
  feedback: PropTypes.shape({
    message: PropTypes.string,
    imageUrl: PropTypes.string,
  }),
};

QuizScoreSummary.defaultProps = {
  feedback: undefined,
};

export default QuizScoreSummary;
